import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import ImpersonationSessionsPaginatedGql from '@/store/graphql/system/queries/ImpersonationSessionsPaginated.gql';
import EndImpersonationSessionGql from '@/store/graphql/system/mutations/EndImpersonationSession.gql';

export default {
    fetchSessionsPaginated: (data) => {
        const filters = _.values(data.filters);

        return apolloClient
            .query({
                query: ImpersonationSessionsPaginatedGql,
                variables: {
                    scope: _.get(data, 'scope', 'base'),
                    type: _.get(data, 'type', 'impersonation_session'),
                    currentPage: _.get(data, 'pageInfo.currentPage', 1),
                    perPage: _.get(data, 'pageInfo.perPage', 25),
                    order: _.get(data, 'variables.order', 'started_at'),
                    direction: _.get(data, 'variables.direction', 'desc'),
                    filters
                },
                fetchPolicy: 'network-only'
            })
            .then(({ data }) => data.ImpersonationSessionsPaginated);
    },

    endSession: (id) =>
        apolloClient
            .mutate({
                mutation: EndImpersonationSessionGql,
                variables: { id: parseInt(id, 10) }
            })
            .then(({ data }) => data.EndImpersonationSession)
};
